import { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { IPartnerDocumentSection } from '../../../../lib/documentsAndLinks'
import { CockpitSectionHeader } from '../../../components/cockpitSectionHeader'
import type { IDocumentsSummaryRow, TDocumentType } from '../../types'
import { CockpitDocumentLinks } from '../cockpitDocumentLinks/CockpitDocumentLinks'
import { DocumentsGroupedRow } from '../documentsGroupedRow/DocumentsGroupedRow'

import styles from './DocumentsGroupedSummary.module.scss'

interface IProps {
  exportPlan?: ReactNode
  documentType: TDocumentType | null
  totalCount: number
  rows: IDocumentsSummaryRow[]
  showLinks: boolean
  linkSections: IPartnerDocumentSection[]
}
const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks

export const DocumentsGroupedSummary = ({
  documentType,
  totalCount,
  rows,
  showLinks,
  linkSections,
  exportPlan,
}: IProps) => {
  return (
    <div className={exportPlan ? `${styles.heroLayout} ${styles.withExport}` : styles.heroLayout}>
      <div>
        <div className={styles.hero}>
          <span className={styles.heroCount}>{totalCount}</span>
          <span>
            {documentType ? (
              `${documentType.toUpperCase()} documents`
            ) : (
              <Translation span text={KEYS.totalDocuments} />
            )}
          </span>
        </div>
        {exportPlan}
      </div>
      <div className={styles.groupRows}>
        {rows.map(({ id, ...row }) => (
          <DocumentsGroupedRow key={id} {...row} />
        ))}
        {documentType && rows.length === 0 && (
          <div className={styles.empty}>
            <Translation span text={documentType === 'elt' ? KEYS.emptyElt : KEYS.emptyQbr} />
          </div>
        )}
        {showLinks && (
          <div className={styles.links}>
            <CockpitSectionHeader>
              <Translation span text={KEYS.sectionLinks} />
            </CockpitSectionHeader>
            {linkSections.length === 0 && <CockpitDocumentLinks />}
            {linkSections.map((section) => (
              <div key={section.partnerId}>
                {linkSections.length > 1 && (
                  <CockpitSectionHeader>{section.partnerName}</CockpitSectionHeader>
                )}
                <CockpitDocumentLinks partnerId={section.partnerId} partnerRtm={section.rtm} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
